import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import EmployeeNavigator from "../../../navigation/EmployeeNavigator";
import styles from "./employeeSettings.module.css";

const EmployeeSettings = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("employees", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/emlpoyees/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <EmployeeNavigator />
    </div>
  );
};

export default EmployeeSettings;
